<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add SCM Item</span>
      <span v-else>Edit SCM Item </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col cols="12" sm="8" class="align-self-center mb-4">
            <section class="file-upload">
              <p>Item Photo</p>
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="profileChange"
                fieldName="mainImgFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <template v-if="form.photo != null">
                <a
                  :href="form.photo"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col cols="12" sm="4">
            <section class="transparent-field mt-8">
              <v-switch
                v-model="form.active"
                inset
                :true-value="1"
                :false-value="0"
                label="Active ?"
                color="success"
              ></v-switch>
            </section>
          </v-col>
          <v-col class="py-2" cols="12" sm="4">
            <form-group name="code" :attribute="`fields.code`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.code"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" cols="12" sm="8">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col class="py-0" cols="12" sm="4">
            <form-group name="category" attribute="fields.category">
              <template slot-scope="{ attrs, listeners }">
                <v-autocomplete
                  :loading="loadingData"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  regular
                  return-object
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.category"
                ></v-autocomplete>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" cols="12" sm="4">
            <form-group name="sub_category" attribute="fields.sub_category">
              <template slot-scope="{ attrs, listeners }">
                <v-autocomplete
                  :items="subCategories"
                  item-text="name"
                  item-value="id"
                  regular
                  return-object
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.sub_category"
                  :disabled="!form.category.id"
                ></v-autocomplete>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" cols="12" sm="4">
            <v-autocomplete
              :items="uoms"
              item-text="name"
              item-value="id"
              regular
              clearable
              :label="$t('fields.unit_of_measure')"
              v-model="form.unit_of_measure"
            ></v-autocomplete>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.yearlyNeed") }}</span>
              <v-text-field
                type="number"
                v-model.number="form.yearly_needed_qty"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.safetyPercent") }}</span>
              <v-text-field
                v-model.number="form.percent_of_safty_stock"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.amountOfPurchace") }}</span>
              <v-text-field
                v-model.number="form.amount_of_purchase"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.minStock") }}</span>
              <v-text-field
                v-model.number="form.min_stock"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.maxStock") }}</span>
              <v-text-field
                v-model.number="form.max_stock"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.reorderQty") }}</span>
              <v-text-field
                v-model.number="form.reorder_qty"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.waitingDays") }}</span>
              <v-text-field
                v-model.number="form.waiting_days"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col class="pt-5" cols="12" sm="4">
            <section class="increment-label">
              <span>{{ $t("label.lastUnitPrice") }}</span>
              <v-text-field
                v-model.number="form.last_unit_price"
                type="number"
              ></v-text-field>
            </section>
          </v-col>
          <v-col cols="12">
            <form-group name="notes" :attribute="`fields.notes`">
              <template slot-scope="{ attrs, listeners }">
                <v-textarea
                  label="Notes"
                  regular
                  v-bind="attrs"
                  v-on="listeners"
                  v-model.trim="form.notes"
                ></v-textarea>
              </template>
            </form-group>
          </v-col>
          <v-col cols="8" class="mx-auto">
            <v-btn
              class="success text-capitalize"
              large
              :loading="submitting"
              type="submit"
              width="100%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData,
} from "@/helpers/apiMethods";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        category: { id: "", name: "" },
        sub_category: { id: "", name: "" },
        unit_of_measure: "",
        code: "",
        name: "",
        yearly_needed_qty: "",
        percent_of_safty_stock: "",
        amount_of_purchase: "",
        min_stock: "",
        max_stock: "",
        reorder_qty: "",
        waiting_days: "",
        last_unit_price: "",
        notes: "",
        photo: "",
        active: 1,
      },
      categories: [],
      uoms: [],
      maxSize: 0.512,
      photoBoolean: true,
      isEdited: false,
      resetBoolean: false,
      profileBoolean: false,
      valueTypes: [{ name: "amount" }, { name: "percentage" }],
      majorsIndex: [],
      globalServerErrors: null,
      loadingData: false,
      start_date_modal: false,
      date_modal: false,
      submitting: false,
    };
  },
  created() {
    this.editCreateBoolean();
    this.indexCategories();
    this.indexUOM();
  },
  computed: {
    subCategories() {
      const category = this.form.category.id;
      let subCategories = [];
      if (this.categories.length !== 0) {
        this.categories.find((item) => {
          if (item.id === category) {
            subCategories = item.sub_categories;
          }
        });
      }
      return subCategories;
    },
  },
  methods: {
    indexCategories() {
      IndexData({ reqName: `scm/categories` })
        .then((res) => {
          const { data } = res.data;
          this.categories = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexUOM() {
      IndexData({ reqName: `scm/unit-of-measures`, query: { enabled: true } })
        .then((res) => {
          const { data } = res.data;
          this.uoms = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createScmCamp();
      } else {
        this.editScmCamp();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `scm/items`,
        id: id,
      })
        .then((res) => {
          const { item } = res.data;
          this.form = item;
          if (item.notes == null) {
            this.form.notes = "";
          }
        })
        .catch(() => {});
    },
    createScmCamp() {
      this.submitting = true;
      const formData = new FormData();
      this.form.unit_of_measure || delete this.form.unit_of_measure;
      for (const key in this.form) {
        if (key == "category" || key == "sub_category") {
          formData.append(key, this.form[key].id);
        } else {
          if (this.form[key] !== "") formData.append(key, this.form[key]);
        }
      }

      StoreData({
        reqName: `scm/items`,
        data: formData,
      })
        .then(() => {
          this.$router.push({
            path: "/scm/items",
            query: { ...this.$route.query },
          });
          this.submitting = false;
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.submitting = false;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    editScmCamp() {
      this.submitting = true;
      if (!this.profileBoolean) {
        delete this.form.photo;
      }
      const formData = new FormData();
      this.form.unit_of_measure || delete this.form.unit_of_measure;
      Object.keys(this.form).forEach((formItem) => {
        if (formItem == "category" || formItem == "sub_category") {
          formData.append(formItem, this.form[formItem].id);
        } else if (this.form[formItem] == null) {
          return;
        } else if (formItem == "unit_of_measure") {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem].id);
          } else {
            return;
          }
        } else if (formItem == "photo") {
          if (this.photoBoolean == false) {
            return;
          }
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `scm/items`,
        data: formData,
        id: this.$route.params.id,
      })
        .then(() => {
          this.isEdited = false;
          this.submitting = false;

        this.$router.push({
            path: "/scm/items",
            query: { ...this.$route.query },
          });
          this.reset();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.submitting = false;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    profileChange(photo) {
      this.form.photo = photo.file;
      this.reset = false;
      this.photoBoolean = false;
      this.profileBoolean = false;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    reset() {
      this.$v.form.$reset();
      this.form = {};
      this.$store.dispatch("ClearServerErrors");
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "edititems") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(191),
      },
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(191),
      },
      category: {
        id: {
          required,
        },
      },
      sub_category: {
        id: {
          required,
        },
      },
      sub_category: {
        id: {
          required,
        },
      },
    },
  },
};
</script>
